import { HubProposal } from '../api/types';

export function hubSearchFilter(data: HubProposal[], searchValue: string) {
  if (!Array.isArray(data) || !data?.length || !searchValue) return data;

  return data.filter(proposal => proposal?.businessName?.toLowerCase().includes(searchValue.toLowerCase()));
}
